<template>
  <div id="app">
    <div v-if="loginSuccess">
      <select v-model="selectedDashboard">
        <!-- <option value="funnel-dashboard">Funnels</option> -->
        <option value="tech-dashboard">Tech-Performance</option>
        <option value="app-usage-dashboard">App Usage</option>
      </select>

      <component :is="selectedDashboard"></component>

      <a @click="logout">Logout</a>
    </div>
    <Login v-else @submit="login"/>
  </div>
</template>

<script>
import TechDashboard from './components/TechDashboard.vue'
import FunnelDashboard from './components/FunnelDashboard.vue'
import AppUsageDashboard from './components/AppUsageDashboard.vue'
import Login from './components/Login.vue'

import Vue from 'vue'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'

import {Graylog} from './graylog'

Vue.use(VueChartkick, {adapter: Chart})

export default {
  name: 'app',
  components: {
    TechDashboard,
    FunnelDashboard,
    AppUsageDashboard,
    Login
  },

  data() {
    return {
      loginSuccess: false,
      selectedDashboard: 'tech-dashboard'
    }
  },

  mounted() {
    let storedCredentialData = localStorage.getItem('graylog-credentials')
    if (storedCredentialData) {
      let storedCredentials = JSON.parse(storedCredentialData)
      Graylog.setBaseUrl(storedCredentials.host)
      Graylog.setApiToken(storedCredentials.apiToken)
      this.loginSuccess = true
    }
  },

  methods: {
    login(host, apiToken) {
      Graylog.setBaseUrl(host)
      Graylog.setApiToken(apiToken)
      Graylog.search('1', {}).then(() => {
        this.loginSuccess = true

        localStorage.setItem('graylog-credentials', JSON.stringify({
          host,
          apiToken
        }))

      }).catch(() => {
        this.loginSuccess = false
      })
    },
    logout() {
      localStorage.setItem('graylog-credentials', null)
      this.loginSuccess = false
    }
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 5px 20px;
}
</style>
